module.exports = __webpack_public_path__ + "img/1655.1874bed3.jpg";